
    <fieldmagic-primary-button
      icon="arrow-left"
      variant="link"
      label="{{ label$ | async }}"
      (click)="onClick()"
      [disabled]="disabled"
    >
    </fieldmagic-primary-button>
  